module.exports = __webpack_public_path__ + "static/media/color_01.42053af8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/color_01.jpg
// module id = 377
// module chunks = 0